import React from 'react';
import {
  IconButton,
  IconPlaySolid,
  IconPauseLine,
  IconArrowStartLine,
  IconArrowEndLine,
  View,
  Pill,
  Text,
} from '@instructure/ui';
import {
  useVideoFragmentStore,
  getStore,
} from '../../../../../stores/StoreContext';
import { formatTime } from '../../../../../helpers/utilities';

const VideoControls = ({ fragmentId }) => {
  const VideoFragmentStore = getStore('videoFragmentStore');

  const currentTime = useVideoFragmentStore(
    (state) => state[fragmentId]?.state?.currentTime
  );
  const startTime = useVideoFragmentStore(
    (state) => state[fragmentId]?.state?.startTime
  );
  const endTime = useVideoFragmentStore(
    (state) => state[fragmentId]?.state?.endTime
  );
  const isPlaying = useVideoFragmentStore(
    (state) => state[fragmentId]?.state?.isPlaying
  );
  const playVideo = () => VideoFragmentStore.play(fragmentId);
  const pauseVideo = () => VideoFragmentStore.pause(fragmentId);
  const stepBackward = () => VideoFragmentStore.stepBackward(fragmentId);
  const stepForward = () => VideoFragmentStore.stepForward(fragmentId);

  return (
    <View as="div" textAlign="center">
      <View as="div" width="100%" textAlign="center" margin="small none">
        {/* Play/Pause Button */}
        {!isPlaying ? (
          <IconButton
            as="span"
            size="small"
            margin="none x-small none none"
            style={{ zIndex: '99999' }}
            screenReaderLabel="Start Playback"
            onClick={playVideo}
          >
            <IconPlaySolid size="x-small" />
          </IconButton>
        ) : (
          <IconButton
            as="span"
            size="small"
            margin="none x-small none none"
            style={{ zIndex: '99999' }}
            screenReaderLabel="Pause Playback"
            onClick={pauseVideo}
          >
            <IconPauseLine size="x-small" />
          </IconButton>
        )}

        {/* Step Backward Button - only show if we're at least 1 second in */}
        {currentTime > startTime + 1 && (
          <IconButton
            as="span"
            size="small"
            margin="none x-small none none"
            style={{ zIndex: '99999' }}
            screenReaderLabel="Step backward one second"
            onClick={stepBackward}
          >
            <IconArrowStartLine size="x-small" />
          </IconButton>
        )}

        {/* Step Forward Button - only show if we're not at the end */}
        {currentTime < endTime - 1 && (
          <IconButton
            as="span"
            size="small"
            margin="none x-small none none"
            style={{ zIndex: '99999' }}
            screenReaderLabel="Step forward one second"
            onClick={stepForward}
          >
            <IconArrowEndLine size="x-small" />
          </IconButton>
        )}
      </View>
      <View as="div" width="100%" textAlign="center">
        <Pill color="warning">
          <Text size="x-small">
            {formatTime(
              isNaN(currentTime) || currentTime < startTime
                ? startTime
                : currentTime
            )}{' '}
            / {formatTime(endTime)}
          </Text>
        </Pill>
      </View>
    </View>
  );
};

export default VideoControls;
